export default __webpack_public_path__ + "static/media/Mercenary's Armguards of the Savage Sun.f40b75ad.jpg";